export function suggestScenarioDatedName(
  scenarioName: string | undefined,
  date: Date = new Date()
): string {
  const trimmedScenarioName = (scenarioName ?? '').trim()
  const datePart = new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short'
  }).format(date)

  return trimmedScenarioName ? `${trimmedScenarioName} - ${datePart}` : datePart
}
